import { Search, Plus } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useNavigate } from "react-router-dom"

interface DocumentSearchProps {
  searchTerm: string
  onSearchChange: (value: string) => void
}

export const DocumentSearch = ({ searchTerm, onSearchChange }: DocumentSearchProps) => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Search className="w-6 h-6 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Meus Documentos</h1>
      </div>
      <div className="flex items-center gap-4 w-full md:w-auto">
        <div className="relative flex-1 md:w-64">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <Input
            type="text"
            placeholder="Buscar documentos..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 w-full"
          />
        </div>
        <Button
          onClick={() => navigate("/")}
          className="bg-primary hover:bg-primary/90 text-white flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Novo Documento
        </Button>
      </div>
    </div>
  )
}